import { render, staticRenderFns } from "./formula-tip.vue?vue&type=template&id=15baf9d0&"
import script from "./formula-tip.vue?vue&type=script&lang=js&"
export * from "./formula-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports